// src/api/authApi.js
import axios from './axios';

// ─── Register ────────────────────────────────────────────────────────────────
export async function registerUser({ name, email, password }) {
  try {
    const { data } = await axios.post('/auth/register', { name, email, password });
    // { success: true, data: { id, name, email, role, createdAt } }
    return data.data;
  } catch (err) {
    console.error('❌ registerUser error:', err);
    throw err.response?.data || err;
  }
}

// ─── Login ───────────────────────────────────────────────────────────────────
export async function loginUser({ email, password }) {
  try {
    const { data } = await axios.post('/auth/login', { email, password });
    // { success: true, data: { token, user } }
    return data.data;
  } catch (err) {
    console.error('❌ loginUser error:', err);
    throw err.response?.data || err;
  }
}

// ─── Verify Email ────────────────────────────────────────────────────────────
export async function verifyEmail(token) {
  try {
    const { data } = await axios.get('/auth/verify-email', {
      params: { token },
    });
    // you might return data.success or any message
    return data;
  } catch (err) {
    console.error('❌ verifyEmail error:', err);
    throw err.response?.data || err;
  }
}

// ─── Forgot Password ──────────────────────────────────────────────────────────
export async function requestPasswordReset(email) {
  try {
    const { data } = await axios.post('/auth/forgot-password', { email });
    // { success: true, message: 'Reset link sent' }
    return data;
  } catch (err) {
    console.error('❌ requestPasswordReset error:', err);
    throw err.response?.data || err;
  }
}

// ─── Reset Password ───────────────────────────────────────────────────────────
export async function resetPassword(token, newPassword) {
  try {
    const { data } = await axios.post('/auth/reset-password', {
      token,
      newPassword,
    });
    // { success: true, message: 'Password updated' }
    return data;
  } catch (err) {
    console.error('❌ resetPassword error:', err);
    throw err.response?.data || err;
  }
}

// ─── Logout ───────────────────────────────────────────────────────────────────
export async function logoutUser() {
  try {
    await axios.post('/auth/logout', {});
  } catch (err) {
    console.error('❌ logoutUser error:', err);
    throw err.response?.data || err;
  }
}
